import formAnimated from "../../../src/scripts/components/form/animated.js";

$(function () {
  formAnimated.init();

  const form = document.querySelector('.block-landings--banner-two-col-form .marketo-form');

  if(form) {
    form.addEventListener('submit', () => {
      setTimeout(() => {
        !form.querySelector('.error') && (form.style.display = "none");
      }, 100);
    })
  }

  if(form) {
    const button = form.querySelector('button');

    button && button.classList.add('disabled');

    const inputs = form.querySelectorAll('input, select');

    inputs.length && inputs.forEach(input => {
      input.addEventListener('change', () => {
        form.checkValidity() && button && button.classList.remove('disabled');
      })
    })
  }
});
